import { atom } from "jotai";
import type { BBox3D } from "../utils/projectionUtils";

export interface AnnotationBBox {
  bbox: BBox3D;
  segmentIndex: number;
}

/**
 * 3D bounding boxes computed from all active-segment contour annotations.
 * Updated by the locked viewport's event listener when annotations change.
 * Read by sibling viewports to render projection overlays.
 */
export const annotationBBoxesAtom = atom<AnnotationBBox[]>([]);
